import React, { useEffect, useMemo, useState } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  TextField,
  Stack,
  Typography,
} from "@mui/material";

export default function CounterOfferDialog({
  open,
  onClose,
  offer,
  suggestedPrice,
  onSubmit,
  loading,
}) {
  const [price, setPrice] = useState("");
  const [message, setMessage] = useState("");
  const [quantity, setQuantity] = useState("1");

  useEffect(() => {
    if (!open) return;
    const start =
      suggestedPrice != null
        ? String(suggestedPrice)
        : offer?.offer_price != null
        ? String(offer.offer_price)
        : "";
    setPrice(start);
    setMessage("");
    setQuantity(String(offer?.quantity || 1));
  }, [open, suggestedPrice, offer]);

  const canSubmit = useMemo(() => {
    const p = parseFloat(price);
    const q = parseInt(quantity, 10);
    return Number.isFinite(p) && p > 0 && Number.isFinite(q) && q > 0;
  }, [price, quantity]);

  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="sm">
      <DialogTitle sx={{ fontWeight: 700 }}>Counter Offer</DialogTitle>
      <DialogContent>
        <Stack spacing={2} sx={{ mt: 1 }}>
          <Typography variant="body2" sx={{ opacity: 0.8 }}>
            Item: <strong>{offer?.card_name || offer?.sku || offer?.item_id || ""}</strong>
          </Typography>
          <TextField
            label="Counter price"
            value={price}
            onChange={(e) => setPrice(e.target.value)}
            fullWidth
          />
          <TextField
            label="Counter quantity"
            value={quantity}
            onChange={(e) => setQuantity(e.target.value)}
            fullWidth
            inputProps={{ inputMode: "numeric", pattern: "[0-9]*" }}
            helperText="eBay requires a counter quantity. Defaults to the buyer offer quantity."
          />
          <TextField
            label="Message to buyer (optional)"
            value={message}
            onChange={(e) => setMessage(e.target.value)}
            fullWidth
            multiline
            minRows={2}
          />
        </Stack>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} disabled={loading}>
          Cancel
        </Button>
        <Button
          variant="contained"
          onClick={() => onSubmit({ counter_price: price, counter_quantity: quantity, message })}
          disabled={!canSubmit || loading}
        >
          Send counter
        </Button>
      </DialogActions>
    </Dialog>
  );
}
